import {getCurrentLang, storeCurrentLang} from "../../data/AuthTokenStorage";

export default {
    name: "SubHeader",
    props: {
        headerItems: {
            
        },
        headColor: String
    },
   
    data() {
        return {
            openList: null,
            openSearch: false,
            searchText: '',
            drawer: false,
            selectedFlag: 0,
            flag: [
                'IR',
                'EN',
                'AR'
            ],
            limitPosition: 0,
            scrolled: false,
            lastPosition: 0,
            // flag:[
            //     require('../../assets/images/flags/iran.png'),
            //     require('../../assets/images/flags/united-kingdom.png'),
            //     require('../../assets/images/flags/saudi-arabia.png'),
            // ],

        }
    },
    methods: {
        isValidHttpUrl(string) {
            let url;
            
            try {
              url = new URL(string);
            } catch (_) {
              return false;  
            }
          
            return url.protocol === "http:" || url.protocol === "https:";
          },
        gotoLink(link){
            if(this.isValidHttpUrl(link)) location.href=link;
            this.$router.push(link)
        },
        getSelectedLang(){
            if (getCurrentLang()==="fa"){
                this.selectedFlag=0;
            }
            else if (getCurrentLang()==="en"){
                this.selectedFlag=1;
            }
            else if (getCurrentLang()==="ar"){
                this.selectedFlag=2;
            }
            else {
                storeCurrentLang('fa');
                this.selectedFlag=0;
            }
        },
        changeLanguage(i) {
            this.selectedFlag = i;
            if (this.selectedFlag === 0) {
                this.$i18n.locale = 'fa';
            }
            if (this.selectedFlag === 1) {
                this.$i18n.locale = 'en'
            }
            if (this.selectedFlag === 2) {
                this.$i18n.locale = 'ar'
            }
            storeCurrentLang(this.$i18n.locale);
        },
        currentColor() {
            if (this.$route.path.indexOf('light-blocks')>0) {
                return '#74B73B';
            } else {
                return '#25458c';
            }
        },
        currentClass() {
            if (this.$route.path.indexOf('light-blocks')>0) {
                return 'block-item';
            } else {
                return 'glass-fake-item';
            }
        },
        currentSingleClass() {
            if (this.$route.path.indexOf('light-blocks')>0) {
                return 'single-block-item';
            } else {
                return 'single-glass-item';
            }
        },
        languageBorderClass() {
            if (this.$route.name === 'mainGlass') {
                return 'glass-lang-border'
            } else {
                return 'block-lang-border'
            }
        },
        /*  search() {
              /!*if (this.searchText.length > 0) {
                  console.log('sssss',this.$route.name);
                  if (this.$route.name!='searchResults'){
                      this.$router.push({
                          name: 'searchResults', params: {
                              text: this.searchText
                          }
                      });
                  }
                  else{
                      this.$router.replace({
                          name: 'searchResults', params: {
                              text: this.searchText
                          }
                      }).catch(()=>{});
                      // this.$store.dispatch('productManager/changeSearchStatus');
                  }


              }*!/
          },*/
        handleScroll() {
            if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                this.scrolled = true;
                // move up!
            }

            if (this.lastPosition > window.scrollY) {
                this.scrolled = false;
                // move down
            }

            this.lastPosition = window.scrollY;
            // this.scrolled = window.scrollY > 250;
        }
    },

    created() {
        this.getSelectedLang();
        window.addEventListener("scroll", this.handleScroll);
        
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
}